/** Internal helper imports here ... */
import intlTelInput from "intl-tel-input";
import utils from "../../../../../../../node_modules/intl-tel-input/build/js/utils.js";
// import utils from "../helpers/utils";

const TelephoneValidation = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.telephoneInputWrapper =
      document.getElementsByClassName("telephone-form");
  };

  const reset = (telephoneInput, telephoneInputElements) => {
    if (telephoneInput && telephoneInput.classList.contains("error")) {
      telephoneInput.classList.remove("error");
    }
    telephoneInputElements.querySelector("#error-msg").innerHTML = "";
    telephoneInputElements.querySelector("#error-msg").classList.add("hide");
    telephoneInputElements.querySelector("#valid-msg").classList.add("hide");
  };

  const validate = (iti, telephoneInputElement, telephoneInputElements) => {
    // on blur: validate
    const errorMap = [
      "Invalid number",
      "Invalid country code",
      "Too short",
      "Too long",
      "Invalid number",
    ];

    telephoneInputElement.addEventListener("blur", (event) => {
      reset(telephoneInputElement, telephoneInputElements);
      if (telephoneInputElement.value.trim()) {
        if (iti.isValidNumber()) {
          telephoneInputElements
            .querySelector("#valid-msg")
            .classList.remove("hide");
        } else {
          telephoneInputElement.classList.add("error");
          const errorCode = iti.getValidationError();
          telephoneInputElements.querySelector("#error-msg").innerHTML =
            errorMap[errorCode];
          telephoneInputElements
            .querySelector("#error-msg")
            .classList.remove("hide");
        }
      }
    });

    // on keyup / change flag: reset
    telephoneInputElement.addEventListener(
      "change",
      reset(telephoneInputElement, telephoneInputElements)
    );
    telephoneInputElement.addEventListener(
      "keyup",
      reset(telephoneInputElement, telephoneInputElements)
    );
  };

  const init = () => {
    cacheDOM();

    if (DOM.telephoneInputWrapper) {
      Array.from(DOM.telephoneInputWrapper).forEach(
        (telephoneInputElements) => {
          const telephoneInputElement =
            telephoneInputElements.querySelector(".telephone");
          const iti = intlTelInput(telephoneInputElement, {
            utilsScript: utils,
            initialCountry: "gb",
            separateDialCode: true,
            customPlaceholder: function () {
              return "7400 123456";
            },
          });

          validate(iti, telephoneInputElement, telephoneInputElements);
        }
      );
    }
  };

  return { init };
})();

export default TelephoneValidation;
